(function() {
  const HEADER_OFFSET = 100; // Adjust based on your header height

  function scrollToHash() {
    if (!window.location.hash) return;
    
    const target = document.querySelector(window.location.hash);
    if (!target) return;

    const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({
      top: elementPosition - HEADER_OFFSET,
      behavior: 'smooth'
    });
  }

  // Wait for full page load (including images)
  window.addEventListener('load', function() {
    if (window.location.hash) {
      // Disable browser's default jump
      const hash = window.location.hash;
      
      // Multiple attempts to ensure correct position after dynamic content loads
      setTimeout(scrollToHash, 100);
      setTimeout(scrollToHash, 500);
      setTimeout(scrollToHash, 1000);
    }
  });
})();